<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4">The voice I hear this passing night was heard  <br/><br/>In ancient days...  <br/><br/>The same that oft-times hath  <br/><br/>Charmed magic casements, opening on the foam  <br/><br/>Of perilous seas, in faery lands forlorn.  <br/><br/><span class="Apple-converted-space">          </span>— Keats</p>
<p class="p2"> </p>
<p class="p2"> </p>
<p class="p3"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?0b965602